// src/components/RequireRole.js
import { useEffect, useState } from 'react'
import { watchAuth } from '../lib/auth'

export default function RequireRole({ allow=['admin'], children }){
  const [session, setSession] = useState(undefined) // undefined = loading
  useEffect(()=>watchAuth(setSession), [])
  if (session===undefined) return <div className="alert alert-info">Chargement…</div>
  if (!session) return <div className="alert alert-danger">Accès refusé — connectez-vous.</div>
  const role = session.claims?.role
  if (!allow.includes(role)) return <div className="alert alert-danger">Accès restreint ({role||'aucun rôle'})</div>
  return children
}
